import type { RecordDetailHeaderPresentation } from "@kontextwerk/web-sdk/ui/layout/recordDetail/types"
import { mdiClipboardTextOutline } from "@mdi/js"
import {
  statusLabels,
  workOrderStatusLabels,
} from "../../../../../../../_shared/_logic/outreach-presentation"
import { archivePresentation } from "../../../../../_shared/_logic/archive-presentation"
import { formatAddressInline } from "../../../../../../../_shared/_logic/countries"
import { formatDateOnlyDisplay } from "../../../../../../_shared/_logic/timezones"
import {
  internalOrderTypeLabel,
  orderTypeHeadingLabel,
} from "../../../../../../../_shared/_logic/order-type-labels"

export const workOrderRecordIcon = mdiClipboardTextOutline

export const buildWorkOrderHeader = (
  workOrder: WorkOrder,
  properties: Property[],
): RecordDetailHeaderPresentation => {
  const fields: RecordDetailHeaderPresentation["fields"] = []
  const workType = internalOrderTypeLabel(workOrder)

  if (workType)
    fields.push({
      id: "work-type",
      label: orderTypeHeadingLabel(workOrder, "Auftragsart"),
      value: workType,
    })

  const property = properties.find(
    (entry) =>
      entry.id === workOrder.property_id && entry.organization_id === workOrder.organization_id,
  )
  const address = property ? formatAddressInline(property) : ""

  if (address) fields.push({ id: "property", label: "Liegenschaft", value: address })

  const deadline = formatDateOnlyDisplay(workOrder.due_date, "")

  if (deadline) fields.push({ id: "deadline", label: "Frist", value: deadline })

  const statusLabel = workOrder.view_status
    ? workOrderStatusLabels[workOrder.view_status]
    : statusLabels[workOrder.status]

  if (statusLabel) fields.push({ id: "status", label: "Status", value: statusLabel })

  return {
    icon: workOrderRecordIcon,
    subtitle: workOrder.archived_at
      ? archivePresentation(workOrder.archived_at, workOrder.archive_reason)
      : undefined,
    fields,
  }
}
